import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import NavigatorMain from './NavigatorMain';
import {AnswerSubmit,getActivityById} from '../action/investmentAction.js';
import { Toast,Modal } from 'antd-mobile/lib';
import { AlertResule,AlertError } from './AnswerAlert'
import Util from '../util';


function closest(el, selector) {
  const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

class AnswerActivityDatillPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chooseFlag:"C",
      alertFlag:false,
      content:"",
      AlertErrorFlag:false,
      chooseFlag2:"C",
      chooseFlag3:"C",
      activityQuestionList:[],
      count:0
    };

  }
  componentDidMount(){
    
  }
  componentWillMount(){
     window._czc.push(["_trackEvent", "华夏财富H5", "答题", "进入答题"]);
     let {dispatch,setActivityId} = this.props
     let data={
      //  activityId:'10000000000000002701'
      activityId:setActivityId.activityId==""?this.props.location.query.activityId:setActivityId.activityId
      // activityId:this.props.location.query.activityId
     }
     let callback =(data)=>{
       console.log('返回值',data)
       let newQuestion=data.content.activityQuestionResponse.map((item,index)=>{
          item['queMask']=''
          item.options.map((itemobj,index)=>{
            itemobj['optMask']=''
            return itemobj
          })
          return item
       })
       console.log(newQuestion)
       this.setState({
        activityQuestionList:newQuestion
       })
     }
     dispatch(getActivityById(data,callback))
  }
  componentWillUnmount(){
    window._czc.push(["_trackEvent", "华夏财富H5", "答题", "离开答题"]);
  }
  succallback(){
    // alert()
  }
  errcallback(msg){
    // alert(msg)
  }
  checkopt(Qid,Oid){
    let {activityQuestionList,count} =this.state
    let newQuestion=activityQuestionList.map((item,index)=>{
      if (item.questionId==Qid) {
        item['queMask']='1'
        item.options.map((itemobj,index)=>{
           if (itemobj.optionId==Oid) {
            itemobj['optMask']='1'
           }else{
            itemobj['optMask']=''
           }
          return itemobj
        })
      }
      return item
   })
   this.setState({
    activityQuestionList:newQuestion,
   })
  }  
  handleChoose(code,num){
    if(num == 1){
      this.setState({
        chooseFlag:code
      })
    }else if(num == 2){
      this.setState({
        chooseFlag2:code
      })
    }else if(num == 3){
      this.setState({
        chooseFlag3:code
      })
    }
    
  }
  submitChoose(){
    let {dispatch,setActivityId} = this.props;
    let {activityQuestionList} =this.state
    console.log(activityQuestionList,)
    let count=0
    let condition=activityQuestionList.some((item)=>item.queMask=='1')
    console.log(condition)
    if (!condition) {
      this.setState({
        AlertErrorFlag:true,
        content:"请先进行答题，再进行提交"
      })
      return
    }
    let condition1=activityQuestionList.some((item)=>item.queMask=='')
    if (condition1) {
      this.setState({
        AlertErrorFlag:true,
        content:"您还有未回答的题目"
      })
      return
    }
    //获取答对题数
    let newQuestion=activityQuestionList.map((item,index)=>{
        item.options.map((itemobj,index)=>{
           if (itemobj.optMask==1&&itemobj.rightAnswer) {
            count++
           }
        })
    })

    this.setState({ count },()=>{
      console.log('count1111',count)
    })
   let newAnswerSheet= activityQuestionList.map((item) => {
    let ary = [];
    for (const itemObj of item.options) {
      if (itemObj.optMask === "1") {
        ary.push({ optionId: itemObj.optionId });
      }
    }
    return { answerOptions: ary, questionId: item.questionId };
  })
  
   console.log(newAnswerSheet)

  let inData={
      activityId:setActivityId.activityId==""?this.props.location.query.activityId:setActivityId.activityId,
      clientType:'hxcfH5',
      answerSheet:JSON.stringify(newAnswerSheet)
    }
    Toast.loading("正在加载");
    dispatch(AnswerSubmit(inData,this.callback.bind(this)))
  }
  callback(e){
    let {count} = this.state;
    console.log(e)
    if(e.code === "0000"){
      if(count==0){
        this.setState({
          alertFlag:true,
          content:"答题完成，您共回答对0道问题，很遗憾不能获得奖励"
        })
      }else{
        this.setState({
          alertFlag:true,
          content: "答题完成，您共回答对"+count+"道问题，共获得"+e.content.point+"智豆，请到APP查看并使用智豆" 
        })
      }
        
    }else{
      this.setState({
        alertFlag:true,
        content:e.message
      })
    }
  }
  handleSure(){
    this.setState({
      AlertErrorFlag:false
    })
  }
  render(){
    let width = window.screen.width;
    let { chooseFlag,content,alertFlag,AlertErrorFlag, activityQuestionList,chooseFlag2, chooseFlag3 } = this.state;
    return (
        <div style={{width: width}}>
          
            <div style={{ width: width,}}>
                 <img
                  src={require('../img/answerTop.png')}
                  style={{ width: width,}}
                 />
            </div>
            <div style={{ width: width,height:(width)/(750/90),fontSize:22,textAlign:"center",background:"#fff"}}>
                <div  style={{color:'#D8342B',padding:10,fontWeight:'bold'}}>
                   题目
                </div>
            </div>
            <div style={{ width: width,paddingLeft:20,paddingRight:20,background:"#fff",paddingBottom:40}}>
 
              {activityQuestionList.map((item,index)=>{
                return(
                  <div style={{padding:10,marginBottom:20}} key={index}>
                        <div style={{width:(width)/(750/650),borderBottomWidth:10,borderColor:'#1B81FF'}}>
                          <span style={{ fontSize:16,color:'#001871',lineHeight:1.8}}>
                          {item.order}、{item.content} 
                          </span>
                          {item.options.map((itemObj,indexObj)=>{
                            return  <div key={indexObj} onClick={ ()=>{ this.checkopt(item.questionId,itemObj.optionId) }} style={{fontSize:14,padding:10,background: itemObj.optMask=='1'?'#FFFAF3':'#EEF6FF',marginTop:12,display:'flex',flexDirection:'row',}}>
                            <span style={{ fontSize:16,width:(width)/(750/40),color:'red',lineHeight:1.4}}>{itemObj.order}:</span>
                            <p style={{width:(width)/(750/560),lineHeight:1.8}}>{itemObj.content} </p>
                        </div>

                          })
                        }

                          {/* <div style={{fontSize:14,padding:10,background:'#FFFAF3',marginTop:20,display:'flex',flexDirection:'row',}}>
                              <span style={{ fontSize:16,width:(width)/(750/40),color:'red',lineHeight:1.4}}>A:</span>
                              <p style={{width:(width)/(750/560),lineHeight:1.8}}> 这是{item}题答案1这是{item}题答案1这是{item}题答案1这是{item}题答案1这是{item}题答案1这是{item}题答案1这是{item}题答案1这是{item}题答案1</p>
                          </div>

                          <div style={{fontSize:14,padding:10,background:'#EEF6FF',marginTop:10,display:'flex',flexDirection:'row',}}>
                            <span style={{fontSize:16,width:(width)/(750/40),color:'red',lineHeight:1.4}}>B:</span>
                            <p style={{width:(width)/(750/560),lineHeight:1.8}}>这是{item}题答案2</p>
                          </div> */}
                        </div>
                </div>
                )

              })} 
                
            </div>

            <div style={{ width: width,background:"#fff",}}>
                <div onClick={ ()=>{ this.submitChoose() }} style={{display:'flex',justifyContent:'center'}}>
                     <img
                      src={require('../img/submitBtn.png')}
                      style={{width:width*0.837 ,height:width*0.16,verticalAlign:'center'}}
                     />
                  </div>
                <div style={{paddingTop:20,paddingBottom:20,fontSize:12,color:'#001871',textAlign:'center'}}>
                    <span>市场有风险 投资需谨慎</span>
                </div>
            </div>
           

            {/* <div className="questionOne" onClick={()=>{ this.handleChoose("A",2) }} style={{width:width, bottom:(width)/(750/642)}}>
              <div  style={{width:width*0.2, height:(width*0.637)/(590/128), background:"rgba(0,0,0,0)"}}> 
                  { chooseFlag2 === "A" ? 
                    <div className="answerChooseFlag"></div> : null
                  }
              </div>
            </div>

            <div className="questionTwo" onClick={()=>{ this.handleChoose("B",2) }} style={{width:width, bottom:(width)/(750/655)}}>
                <div  style={{width:width*0.2, height:(width*0.637)/(590/128), background:"rgba(0,0,0,0)"}}>
                  {chooseFlag2 === "B" ?
                   <div className="answerChooseFlag"></div> : null
                  }
                </div>
            </div>

             <div className="questionOne" onClick={()=>{ this.handleChoose("A",3) }} style={{width:width, bottom:(width)/(750/408)}}>
              <div  style={{width:width*0.2, height:(width*0.637)/(590/128), background:"rgba(0,0,0,0)"}}> 
                  { chooseFlag3 === "A" ? 
                    <div className="answerChooseFlag"></div> : null
                  }
              </div>
            </div>

            <div className="questionTwo" onClick={()=>{ this.handleChoose("B",3) }} style={{width:width, bottom:(width)/(750/332)}}>
                <div  style={{width:width*0.2, height:(width*0.637)/(590/128), background:"rgba(0,0,0,0)"}}>
                  {chooseFlag3 === "B" ?
                   <div className="answerChooseFlag"></div> : null
                  }
                </div>
            </div> 
 */}



            {/* <div className="sureAnswerBtn" style={{width:width, bottom:(width)/(750/105)}}>
              <div onClick={ ()=>{ this.submitChoose() }} style={{width:width*0.837, height:(width*0.637)/(478/101), background:"pink",fontSize:28,textAlign:'center'}}>
                  答完了，确认提交
              </div>
            </div> */}

            
            {
              AlertErrorFlag?<AlertError content={content} handleSure={this.handleSure.bind(this)}/> : null
            }
            {
              alertFlag?<AlertResule content={content} /> : null
            }
        </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  console.log(state,state.setActivityId,'1212121')
  return {
    setActivityId:state.setActivityId
  }
}

export default connect(mapStateToProps)(AnswerActivityDatillPage);




// WEBPACK FOOTER //
// ./src/components/AnswerActivityDatillPage.js